import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportRoutingModule } from './report-routing.module';
import { SharedModule } from '@shared/shared.module';
import { services } from './services';
import { components } from './components';
import { containerComponents } from './containers';
import { pipes } from './pipes';

@NgModule({
  declarations: [components, containerComponents, pipes],
  imports: [
    CommonModule,

    // internals
    SharedModule,
    ReportRoutingModule,
  ],
  providers: [services, pipes],
})
export class ReportModule {}
